<template>
  <div>
    <div class="footer">
      <div class="footer-content content">
        <div class="footer-top flex-sb">
          <div class="flex-fs">
            <div class="footer-top-left">山东省科教人才发展继续教育平台</div>
            <div class="footer-top-middle">
              <div>联系电话:0531-111111</div>
              <div>邮箱: zhongkejianzhu@QQ.com</div>
              <div>地址: 山东省济南市市中心六路小纬四路46-1号507</div>
              <div><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
              >鲁ICP备2025180444号-1</a
              ></div>
            </div>
          </div>
          <div class="footer-top-right">
            <p>友情链接：</p>
            <a href="https://www.mohurd.gov.cn" target="_blank">中华人民共和国住房和城乡建设部</a>
            <a href="https://jzsc.mohurd.gov.cn" target="_blank">全国建筑市场监管公共服务平台</a>
            <a href="http://zjt.shandong.gov.cn" target="_blank">山东省住房和城乡建设厅</a>
            <a href="http://www.shandong.gov.cn/col/col94091" target="_blank">山东省人民政府</a>
            <a href="https://119.148.161.89:8001/const/index" target="_blank">山东省建设从业人员管理系统</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {},
};
</script>
<style lang="less" scoped>
.footer {
  height: 300px;
  font-size: 16px;
  background-image: url(../assets/image/footer/bg.jpg);
  background-size: 100% 100%;
  min-width: 1600px;
  &-top {
    color: #fff;
    height: 228px;
    &-left {
      font-size: 26px;
      font-weight: bold;
      margin-right: 190px;
    }
    &-middle {
      div:nth-child(1) {
        margin-bottom: 15px;
      }
    }
    &-right {
      margin-right: 85px;
      margin-top: -40px;
    }
  }
  &-bottom {
    color: #939393;

    height: 72px;
    line-height: 75px;
    text-align: right;
    a{
      color: #939393;
      text-decoration: none;
    }
  }
}
.friendlink-title{
  font-size: 24px;
  text-indent: 1em;
  line-height: 25px;
  border-left: #007bee 8px solid;
  margin-bottom: 40px;
}
.lins-box{
  display: flex;
  justify-content: space-between;
}
.lins-box a{
  text-decoration: none;
  color: #333333;
  margin-right: 30px;
  border: 1px #cccccc solid;
  padding: 5px 10px;
}
.link{
  margin-bottom: 40px;
}
.footer-top-right a{
  display: block;
  color: #ffffff;

}
a{
  text-decoration: none;
}
.footer-top-right p{
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}
.footer-top-middle a{
  color: #ffffff;
}
</style>
